import React, { useEffect, useState } from 'react';
import { toInteger } from 'lodash';

import {
  Box,
  Container,
  makeStyles,
  Card,
  CardContent
} from '@material-ui/core';

import { BsFillPersonFill } from "react-icons/bs";

import Page from 'src/components/Page';
import api from '../../services/api'
import agm from '../../services/agm';

import Alerts from '../../utils/alerts';
import Confirmations from '../../utils/confirmations';

import Results from './Results';
import Toolbar from './Toolbar';
import User from './User';
import Create from './Create';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const defaultItem = {
  avatar: "user.svg",
  firstname: '',
  lastname: '',
  email: '',
  phone1: '',
  phone2: '',
  password: '',
  login: '',
  profile: '',
  externalgroup: null,
  externalid: null
}

const defaultDependencies = {
  loaded: false,
  profiles: [],
  externalGroups: [],
  externalIds: []
}

const defaultState = {
  loaded: false,
  records: 10,
  pages: 0,
  page: 0,
  count: 0,
  rows: []
}

const defaultStartDateTime = new Date();
const defaultEndDateTime = new Date();

const MODE_FULL = 0;
const MODE_COMPACT = 1;
const LEVEL_ACCESS_HIDE = -1;
const LEVEL_ACCESS_DISABLED = 0;
const LEVEL_ACCESS_ENABLED = 1;

const defaultResultColumns = [
  { name: 'Nome', field: 'item.firstname + " " + item.lastname', size: -1, sortable: 'firstname', exportable: 0, wrap: 1 },
  { name: 'E-mail', field: 'item.email', size: -1, sortable: null, exportable: 0, wrap: 0 },
  { name: 'Telefone', field: 'item.phone1', size: -1, sortable: null, exportable: 0, wrap: 1 },
  { name: 'Celular', field: 'item.phone2', size: -1, sortable: null, exportable: 0, wrap: 0 },
  { name: 'Login', field: 'item.login', size: -1, sortable: 'enabled', exportable: 0, wrap: 1 },
  { name: 'Perfil', field: 'profileName(profiles, item.profile)', size: -1, sortable: null, exportable: 0, wrap: 1 },
  { name: 'Criação', field: 'formatDate(item.createdAt)', size: -1, sortable: 'createdAt', exportable: 0, wrap: 1 }
];

const defaultEmptyMessage = "Nenhum Usuário Foi Encontrado.";

const defaultfullMode = {
  mode: MODE_FULL,
  create: LEVEL_ACCESS_ENABLED,
  update: LEVEL_ACCESS_ENABLED,
  delete: LEVEL_ACCESS_ENABLED,
  config: LEVEL_ACCESS_HIDE,
  export: LEVEL_ACCESS_HIDE,
  empty: defaultEmptyMessage,
  columns: defaultResultColumns
};

const defaultCompactMode = {
  mode: MODE_COMPACT,
  create: LEVEL_ACCESS_ENABLED,
  update: LEVEL_ACCESS_ENABLED,
  delete: LEVEL_ACCESS_ENABLED,
  config: LEVEL_ACCESS_HIDE,
  export: LEVEL_ACCESS_HIDE,
  empty: defaultEmptyMessage,
  columns: defaultResultColumns
};

const defaultResultModes = [defaultfullMode, defaultCompactMode];

const defaultVisions = [
  { id: 1, name: 'Usuários pelo Nome', refine: 1, label: 'Nome do usuário', history: 0 },
  { id: 2, name: 'Usuários pelo Nome e Data de Criação', refine: 2, label: 'Nome do usuário', history: 1 }
];

const defaultFilter = {
  pagina: 0,
  registros: 10,
  inicio: defaultStartDateTime,
  final: defaultEndDateTime,
  palavrachave: '',
  ordenacao: 'asc',
  ordem: '',
  visao: defaultVisions[0]
}

const Users = () => {

  const classes = useStyles();

  const [item, setItem] = useState(defaultItem);
  const [openCreationDialog, setOpenCreationDialog] = useState(false);
  const [openEditionDialog, setOpenEditionDialog] = useState(false);
  const [openDeletionDialog, setOpenDeletionDialog] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [message, setMessage] = useState({});
  const [filter, setFilter] = useState(defaultFilter);
  const [vision, setVision] = useState(defaultVisions[0]);
  const [resultModes, setResultModes] = useState(defaultResultModes);
  const [selectedMode, setSelectedMode] = useState(MODE_FULL);
  const [dependencies, setDependencies] = useState(defaultDependencies);
  const [openTreatmentDialog, setOpenTreatmentDialog] = useState(false);
  const [profiles, setProfiles] = useState([]);

  const [state, setState] = useState(defaultState);

  const [companyId, setCompanyId] = useState(localStorage.getItem('companyid'));

  const openExportDialog = async (format) => {
    setMessage({ error: true, warn: true, detail: "Função não implementada." });
    setOpenAlert(true);
  }

  const openEdition = async (item) => {
    setItem(item);
    await agm.get('/prestadoras/tecnicos/' + ((item.externalgroup) ? item.externalgroup : '-1'), {}, {}).then((response) => {
      if (!response.data.error) {
        setDependencies({
          loaded: true,
          profiles: profiles,
          externalGroups: response.data.prestadoras,
          externalIds: response.data.tecnicos
        });
        setOpenEditionDialog(true);
      } else {
        setMessage(response.data);
        setOpenAlert(true);
      }
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: "Erro ao Recuperar Prestadoras", detail: error.message });
      setOpenAlert(true);
    })
  }

  const openCreation = async (item) => {
    setItem(item);
    await agm.get('/prestadoras/tecnicos/' + ((item.externalgroup) ? item.externalgroup : '-1'), {}, {}).then((response) => {
      if (!response.data.error) {
        setDependencies({
          loaded: true,
          profiles: profiles,
          externalGroups: response.data.prestadoras,
          externalIds: response.data.tecnicos
        });
        setOpenCreationDialog(true);
      } else {
        setMessage(response.data);
        setOpenAlert(true);
      }
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: "Erro ao Recuperar Prestadoras", detail: error.message });
      setOpenAlert(true);
    })
  }

  const openDeletion = (item) => {
    setItem(item);
    setMessage({
      title: 'Usuário',
      message: 'Deseja excluir o usuário selecionado?',
      warn: 'Esta ação irá apagar todos os dados do usuário e seu acesso ao sistema.',
      details: ['Os dados excluídos não poderam ser recuperados.']
    });
    setOpenDeletionDialog(true);
  }

  const openTreatment = (item) => {
    setItem(item);
    setMessage({ error: true, warn: true, detail: "Função não implementada." });
    setOpenAlert(true);
  }

  const closeDeletion = () => {
    setOpenDeletionDialog(false);
  };

  const closeEdition = () => {
    setOpenEditionDialog(false);
  };

  const closeCreation = () => {
    setOpenCreationDialog(false);
  };

  const closeTreatment = () => {
    setOpenTreatmentDialog(false);
  };

  const closeAlert = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenAlert(false);
  };

  const updateTreatmentValues = (values) => {
    setItem(values);
    refreshItems();
  }

  const updateValues = (values) => {
    api.put('/users/' + values._id, values).then((response) => {
      if (!response.data.error) {
        refreshItems();
        closeEdition();
      }
      setMessage(response.data);
      setOpenAlert(true);
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: 'Erro ao atualizar o usuário.', detail: error.message });
      setOpenAlert(true);
    })
  };

  const createValues = (values) => {
    values.company = companyId;
    api.post('/users', values).then((response) => {
      if (!response.data.error) {
        refreshItems();
        closeCreation();
      }
      setMessage(response.data);
      setOpenAlert(true);
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: 'Erro ao criar o usuário.', detail: error.message });
      setOpenAlert(true);
    })
  };

  const updateDependencies = async (values) => {
    await agm.get('/prestadoras/tecnicos/' + ((item.externalgroup) ? item.externalgroup : '-1'), {}, {}).then((response) => {
      if (!response.data.error) {
        setDependencies({
          loaded: true,
          profiles: profiles,
          externalGroups: response.data.prestadoras,
          externalIds: response.data.tecnicos
        });
      }
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: "Erro ao Recuperar Prestadoras", detail: error.message });
      setOpenAlert(true);
    })
  }

  const deleteValues = (values) => {
    api.delete('/users/' + values._id).then((response) => {
      if (!response.data.error) {
        refreshItems();
      }
      closeDeletion();
      setMessage(response.data);
      setOpenAlert(true);
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: 'Erro ao remover o usuário.', detail: error.message });
      setOpenAlert(true);
    })
  };

  const changeSort = (column, order) => {
    var value = {
      ...filter,
      ordem: column.sortable,
      ordenacao: order,
      pagina: 0,
    };
    setFilter(value);
    api.post('/users/history', { filtro: value, company: companyId }, {}).then((response) => {
      if (!response.data.error) {
        setState({
          loaded: true,
          pages: ((response.data.count > 0) ? toInteger((response.data.count / value.registros)) + 1 : 0),
          page: (response.data.count == 0) ? 0 : value.pagina + 1,
          count: response.data.count,
          rows: response.data.rows
        });
        setDependencies({
          loaded: true,
          profiles: response.data.profiles,
          externalGroups: [],
          externalIds: []
        });
        setProfiles(response.data.profiles);
      } else {
        setState(defaultState);
        setMessage(response.data);
        setOpenAlert(true);
      }
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: 'Erro ao recuperar lista de usuários.', detail: error.message });
      setOpenAlert(true);
    })
  }

  const changeFilter = (startDateTime, endDateTime, vision, keyword, page, rows) => {
    var value = {
      ...filter,
      pagina: page,
      registros: rows,
      inicio: startDateTime,
      final: endDateTime,
      palavrachave: keyword,
      visao: vision
    };
    setVision(vision);
    setFilter(value);
    api.post('/users/history', { filtro: value, company: companyId }, {}).then((response) => {
      if (!response.data.error) {
        setState({
          loaded: true,
          pages: ((response.data.count > 0) ? toInteger((response.data.count / value.registros)) + 1 : 0),
          page: (response.data.count == 0) ? 0 : value.pagina + 1,
          count: response.data.count,
          rows: response.data.rows
        });
        setDependencies({
          loaded: true,
          profiles: response.data.profiles,
          externalGroups: [],
          externalIds: []
        });
        setProfiles(response.data.profiles);
      } else {
        setState(defaultState);
        setMessage(response.data);
        setOpenAlert(true);
      }
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: 'Erro ao recuperar lista de usuários.', detail: error.message });
      setOpenAlert(true);
    })
  }

  const refreshItems = () => {
    api.post('/users/history', { filtro: filter, company: companyId }, {}).then((response) => {
      if (!response.data.error) {
        setState({
          loaded: true,
          pages: ((response.data.count > 0) ? toInteger((response.data.count / filter.registros)) + 1 : 0),
          page: (response.data.count == 0) ? 0 : filter.pagina + 1,
          count: response.data.count,
          rows: response.data.rows
        });
        setDependencies({
          loaded: true,
          profiles: response.data.profiles,
          externalGroups: [],
          externalIds: []
        });
        setProfiles(response.data.profiles);
      } else {
        setState(defaultState);
        setMessage(response.data);
        setOpenAlert(true);
      }
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: 'Erro ao recuperar lista de usuários.', detail: error.message });
      setOpenAlert(true);
    })
  }

  useEffect(() => {
    if (!state.loaded) {
      refreshItems();
    }
    return
  }, []);

  return (
    <Page
      className={classes.root}
      title="Usuário"
    >
      <Container maxWidth={false}>

        <Toolbar
          icon={BsFillPersonFill}
          item={defaultItem}
          resultset={state}
          resultModes={resultModes}
          vision={vision}
          visions={defaultVisions}
          selectedMode={selectedMode}
          openCreation={openCreation}
          changeFilter={changeFilter}
        />

        <Alerts message={message}
          open={openAlert}
          closeAlert={closeAlert} />

        <Confirmations item={item}
          message={message}
          open={openDeletionDialog}
          close={closeDeletion}
          confirmation={deleteValues} />

        <Confirmations item={item}
          message={message}
          open={openTreatmentDialog}
          close={closeTreatment}
          confirmation={updateTreatmentValues} />

        <User item={item}
          open={openEditionDialog}
          closeEdition={closeEdition}
          updateValues={updateValues}
          dependencies={dependencies}
          updateDependencies={updateDependencies}
        />

        <Create item={item}
          open={openCreationDialog}
          closeCreation={closeCreation}
          createValues={createValues}
          dependencies={dependencies}
          updateDependencies={updateDependencies}
        />

        <Box mt={3}>
          <Card>
            <CardContent>
              <Results
                resultSet={state}
                resultModes={resultModes}
                icon={BsFillPersonFill}
                vision={vision}
                selectedMode={selectedMode}
                openEdition={openEdition}
                openDeletion={openDeletion}
                openTreatment={openTreatment}
                openExportDialog={openExportDialog}
                changeSort={changeSort}
                dependencies={dependencies}
              />
            </CardContent>
          </Card>
        </Box>

      </Container>
    </Page>
  );
};

export default Users;
